import EnumService from '../../EnumService'

export default class StatusAtividadeEnumService extends EnumService{

    constructor(){
        super('enumStatusAtividade');
    }
  
}
